import { CloseOutlined } from '@ant-design/icons'
import { useQuery } from '@tanstack/react-query'
import { Modal, Input, Table, Button, Select } from 'antd'
import moment from 'moment'
import React, { useEffect, useState, useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import CarIcon from '@assets/icons/CarSvg'
import ViewIcon from '@assets/icons/viewSvg'
import ErrorModal from '@Modal/ErrorModal'
import SuccessModal from '@Modal/SuccessModal'
import { http } from '@services/http'
import { columnLandedCosts } from '@utils/columns'
import { fetchLandedCostsByPurchaseInvoice } from '@utils/fetchData'
import { handleNavigateCarInvoices } from '@utils/navigateToPdf'

import {
	formatNumberWithSpaces,
	numberWithSpacesIntl,
} from '@utils/numberWithSpaces'
import CreteLandedCostsModal from '../createLandedCostsModal'

import InvoiceVendorPaymentModal from '../invoiceVendorPaymentModal'



import ViewDetailedPurchaseIncomingModal from './detailedPurchaseIncoming'


const LandedCostsByPurchase = ({ data, onClose }) => {
	const { t } = useTranslation()

	const successRef = useRef()
	const errorRef = useRef()

	const roleNames = useSelector((state) => state.main.roleNames)
	const employeeId = useSelector((state) => state.main.employeeId)
	const salesPersonCode = useSelector((state) => state.main.salesPersonCode)

	const [dueDate, setDueDate] = useState('')
	const [shipBtnLoading, setShipBtnLoading] = useState(false)
	const [status, setStatus] = useState('')
	const [isModalVisible, setIsModalVisible] = useState(false)
	const [isViewModalVisible, setIsViewModalVisible] = useState(false)
	const [dopZatrataModal, setDopZatrataModal] = useState(false)
	const [isPaymentModalVisible, setIsPaymentModalVisible] = useState(false)
	const [selectedRowData, setSelectedRowData] = useState(null)

	const {
		data: landedCostsData = [],
		isLoading: loadingLandedCosts,
		refetch: refetchLandedCosts,
	} = useQuery({
		queryKey: ['landedCosts', data?.docEntry],
		queryFn: fetchLandedCostsByPurchaseInvoice,
		keepPreviousData: true,
		refetchOnWindowFocus: true,
		enabled: !!data?.docEntry,
	})

	const docCur =
		(landedCostsData[0]?.docCur && landedCostsData[0]?.docCur) || ''
	const docTotal =
		(landedCostsData[0]?.docTotal && landedCostsData[0]?.docTotal) || 0

	const handleButtonClick = () => {
		setIsModalVisible(true)
	}

	const handleModalYes = () => {
		setDopZatrataModal(true)
		setIsModalVisible(false)
	}

	const handleModalNo = () => {
		finishSalePost()
		setIsModalVisible(false)
	}

	const onView = (record) => {
		setSelectedRowData(record)
		setIsViewModalVisible(true)
	}

	const handleModalCancel = () => {
		setIsModalVisible(false)
	}
	useEffect(() => {
		if (data?.u_Status) {
			setStatus(data.u_Status)
		}
		console.log('Data  = ', data)
	}, [data])

	if (!data) return null

	const tableData = data?.documentLines.map((item, index) => ({
		...item,
		key: index,
		itemDescription: item.itemDescription,
		quantity: item.quantity,
		price: item.price,
		lineTotal: item.lineTotal,
		whsName: item.whsName,
		ugpCode: item.ugpCode,
		docNum: item.docNum,
		docEntry: item.docEntry,
	}))

	const columns = [
		{
			title: t('costType'),
			dataIndex: 'alcName',
			key: 'alcName',
			text: 'center',
		},

		{
			title: t('costSum'),
			dataIndex: 'costSum',
			key: 'costSum',
			text: 'center',
			render: (text, record) => {
				const formattedText = new Intl.NumberFormat('fr-FR').format(
					text,
				)
				return (
					<span>
						{formattedText} {docCur}
					</span>
				)
			},
		},
	]

	const columnsItems = [
		{
			title: t('item'),
			dataIndex: 'dscription',
			key: 'dscription',
			width: 200,
			render: (text, record, index) => {
				return <span>{text}</span>
			},
		},

		{
			title: t('kv.m'),
			dataIndex: 'quantity',
			key: 'quantity',
			render: (text, record, index) => {
				const formattedText = new Intl.NumberFormat('fr-FR').format(
					text,
				)
				return <span>{formattedText}</span>
			},
		},
		{
			title: t('Sotib olish narxi'),
			dataIndex: 'priceFOB',
			key: 'priceFOB',
			render: (text, record, index) => {
				const formattedText = new Intl.NumberFormat('fr-FR').format(
					text,
				)
				return (
					<span>
						{formattedText} {record?.currency}
					</span>
				)
			},
		},
		{
			title: t('landedCost'),
			dataIndex: 'cost',
			key: 'cost',
			render: (text, record, index) => {
				const formattedText = new Intl.NumberFormat('fr-FR').format(
					text,
				)
				return (
					<span>
						{formattedText} {docCur}
					</span>
				)
			},
		},
		{
			title: t('priceAtWh'),
			dataIndex: 'priceAtWH',
			key: 'priceAtWH',
			render: (text, record, index) => {
				const formattedText = new Intl.NumberFormat('fr-FR').format(
					text,
				)
				return (
					<span>
						{formattedText} {docCur}
					</span>
				)
			},
		},

		{
			title: t('ttlExpndLC'),
			dataIndex: 'ttlExpndLC',
			key: 'ttlExpndLC',
			render: (text, record, index) => {
				const formattedText = new Intl.NumberFormat('fr-FR').format(
					text,
				)
				return (
					<span>
						{formattedText} {docCur}
					</span>
				)
			},
		},

		{
			title: t('lineTotal'),
			dataIndex: 'lineTotal',
			key: 'lineTotal',
			render: (text, record, index) => {
				const formattedText = new Intl.NumberFormat('fr-FR').format(
					text,
				)
				return (
					<span>
						{formattedText} {docCur}
					</span>
				)
			},
		},
	]

	return (
		<div className="w-full px-4 sm:px-14">
			<div className="w-full">
				<div className="flex flex-col items-center gap-7 sm:flex-row">
					<div className="flex flex-col gap-1">
						<p className="font-bold">{t('supplier')}</p>
						<Input
							type="text"
							value={landedCostsData[0]?.suppName}
							style={{ color: 'black' }}
							disabled
						/>
					</div>
					<div className="flex flex-col gap-1">
						<p className="font-bold">{t('date')}</p>
						<Input
							type="text"
							value={moment(landedCostsData[0]?.docDate).format(
								'DD.MM.YYYY',
							)}
							style={{ color: 'black' }}
							disabled
						/>
					</div>
					<div className="flex flex-col gap-1">
						<p className="font-bold">{t('totalPrice')}</p>
						<Input
							type="text"
							value={`${numberWithSpacesIntl(docTotal)} ${docCur}`}
							style={{ color: 'black' }}
							disabled
						/>
					</div>
					<div className="flex flex-col gap-1">
						<p className="font-bold">{t('comments')}</p>
						<Input.TextArea
							type="text"
							value={landedCostsData[0]?.descr}
							style={{ color: 'black' }}
							className="w-[400px]"
							disabled
						/>
					</div>
				</div>
				<Table
					columns={columns}
					dataSource={landedCostsData[0]?.landedCostCostLines}
					loading={loadingLandedCosts}
					pagination={false}
					className="border-1 mt-12 border-black"
					scroll={{ x: '100%' }}
					bordered
					summary={(pageData) => {
						const total = pageData.reduce(
							(total, item) => total + item.costSum,
							0,
						)

						return (
							<Table.Summary fixed="bottom">
								<Table.Summary.Row>
									<Table.Summary.Cell
										index={0}
										colSpan={1}
										className="font-bold text-black text-center"
									>
										{t('total')}
									</Table.Summary.Cell>
									<Table.Summary.Cell
										index={2}
										className="font-bold text-black"
									>
										{formatNumberWithSpaces(total)} {docCur}
									</Table.Summary.Cell>
								</Table.Summary.Row>
							</Table.Summary>
						)
					}}
				/>
				<Table
					columns={columnsItems}
					dataSource={landedCostsData[0]?.landedCostItemLines}
					loading={loadingLandedCosts}
					pagination={false}
					className="border-1 mt-12 border-black"
					scroll={{ x: '100%' }}
					bordered
					// summary={(pageData) => {
					// 	const total = pageData.reduce(
					// 		(total, item) => total + item.costSum,
					// 		0,
					// 	)

					// 	return (
					// 		<Table.Summary fixed="bottom">
					// 			<Table.Summary.Row>
					// 				<Table.Summary.Cell
					// 					index={0}
					// 					colSpan={1}
					// 					className="font-bold text-black text-center"
					// 				>
					// 					{t('total')}
					// 				</Table.Summary.Cell>
					// 				<Table.Summary.Cell
					// 					index={2}
					// 					className="font-bold text-black"
					// 				>
					// 					{formatNumberWithSpaces(total)}
					// 				</Table.Summary.Cell>
					// 			</Table.Summary.Row>
					// 		</Table.Summary>
					// 	)
					// }}
				/>
			</div>

			<SuccessModal
				getRef={(r) => {
					successRef.current = r
				}}
			/>
			<ErrorModal
				getRef={(r) => {
					errorRef.current = r
				}}
			/>
			<ViewDetailedPurchaseIncomingModal
				data={selectedRowData}
				onClose={() => {
					setIsViewModalVisible(false)
				}}
				visible={isViewModalVisible}
				refetch={refetchLandedCosts}
			/>
		</div>
	)
}

export default LandedCostsByPurchase
